// src/modules/competition/components/CakeGiverCard/index.js
import React from 'react';
import { Card, Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CakeGiverCard = ({ competitor }) => {
    if (!competitor) return (
        <Card className="mb-3 h-100">
            <Card.Header as="h5">Current Cake Giver</Card.Header>
            <Card.Body className="text-center">
                <Card.Title>No cake Giver 🍰</Card.Title>
            </Card.Body>
        </Card>
    )

    return (
        <Card className="mb-3 h-100">
            <Card.Header as="h5">Current Cake Giver</Card.Header>
            <Card.Body className="text-center">
                <Image
                    src={competitor.profilePicture || '/default-avatar.png'}
                    roundedCircle
                    style={{ width: '100px', height: '100px', objectFit: 'cover', marginBottom: '1rem' }}
                    alt={`${competitor.firstName}'s profile`}
                />
                <Card.Title>{competitor.firstName} 🍰</Card.Title>
                <Card.Text>
                    Points Current Period: {competitor.totalPoints?.toFixed(2)}
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

CakeGiverCard.propTypes = {
    competitor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        profilePicture: PropTypes.string,
        totalPoints: PropTypes.number.isRequired
    })
};

export default CakeGiverCard;
